module.exports = __webpack_public_path__ + "img/clouds.5eac134b.png";